import { EmeraldIcon } from "@emerald-react/icon";
import React from "react";

const MapOverlay: React.FC = () => {
  return (
    <div className="absolute z-1 bg-white-50 w-full h-full top-0 flex flex-col justify-center items-center">
      <p className="border mx-10 items-center p-4 bg-overlay-bg text-overlay-info rounded flex text-sm">
        <EmeraldIcon
          icon="not_listed_location"
          type="filled"
          variant="icon"
          className="text-overlay-info mr-2"
        />
        To add a map pin for this property, verify an address or enter
        coordinates.
      </p>
    </div>
  );
};

export default MapOverlay;
